<script setup lang="ts">
import { Link } from 'lucide-vue-next'
import { useToast } from '~/components/ui/toast'
import type { IProps } from './'

const props = defineProps<IProps>()
const { toast } = useToast()

const copyLinkToClipboard = async () => {
  const currentUrl = new URL(window.location.href)
  currentUrl.hash = props.id

  try {
    await navigator.clipboard.writeText(currentUrl.toString())
    toast({
      title: 'Ссылка скопирована!',
      description: 'Ссылка на этот раздел скопирована в буфер обмена',
      variant: 'default'
    })
  } catch (err) {
    console.error('Failed to copy link:', err)
    toast({
      title: 'Ошибка',
      description: 'Не удалось скопировать ссылку',
      variant: 'destructive'
    })
  }
}
</script>

<template>
  <div
    :id="props.id"
    :class="{
      'space-y-5': true,
      'rounded-lg p-4 md:p-6': props.variant === 'white' || props.variant === 'blue',
      'bg-white': props.variant === 'white',
      'bg-blue-50': props.variant === 'blue'
    }"
  >
    <div v-if="props.headingText" class="group relative">
      <Heading :tag="props.headingTag ?? 'h2'" :class="props.headingClass ?? (props.headingTag ? '' : 'h4')">
        {{ props.headingText }}
      </Heading>
      <button
        v-if="props.showLinkIcon"
        class="AnchorLinkButton"
        :title="$t('common.copy_link')"
        @click="copyLinkToClipboard"
      >
        <Link class="h-3 w-3" />
      </button>
    </div>
    <slot />
  </div>
</template>
